import * as React from "react"

const SvgComponent = (props) => ( 
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clip-path="url(#clip0_40435_2746)">
        <path d="M39.1899 34.8278H6.74956C5.35036 34.8278 4.32287 33.6926 4.45593 32.2934L6.0336 15.7068C6.16665 14.3076 7.40957 13.1724 8.80982 13.1724H41.2502C42.6494 13.1724 43.6769 14.3076 43.5438 15.7068L41.9661 32.2934C41.8331 33.6926 40.5902 34.8278 39.191 34.8278H39.1899Z" fill="#4F87FF"/>
        <path d="M41 17.4858H8" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8.3905 28.3618C8.45306 27.8614 8.87846 27.4858 9.38278 27.4858H14.3672C14.9687 27.4858 15.4341 28.013 15.3595 28.6099L15.1095 30.6099C15.0469 31.1103 14.6215 31.4858 14.1172 31.4858H9.13278C8.53128 31.4858 8.0659 30.9587 8.1405 30.3618L8.3905 28.3618Z" stroke="white"/>
        </g>
        <defs>
        <clipPath id="clip0_40435_2746">
<rect width="39.1111" height="21.6554" fill="white" transform="translate(4.44434 13.1724)"/>
        </clipPath>
        </defs>
    </svg>
    );

export default SvgComponent;